








































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    name: "InputCheckbox",

    props: {
        inputLabel: {
            type: String,
            required: true
        },
        // `Boolean` or `null`. That’s why `required isn’t specified`.
        value: {
            type: Boolean,
        },
        name: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        tooltip: {
            type: String,
            required: false,
            default: ""
        },
    },

    data: function() {
        return {
            uniqueId: (this.specificId !== "") ? this.specificId : uuidv4() as string,
        };
    },

    computed: {
        model: {
            get: function(): boolean {
                return this.value;
            },
            set: function(value: boolean) {
                this.$emit("input", value);
            }
        },
    },
});
